/* @flow */

import React from 'react';

import { Route, IndexRoute } from 'react-router';
import { loadRoute, render, ViewerQueries } from 'depop/router';

export default (
  <Route path="password-reset">
    <IndexRoute getComponent={(location, cb) => loadRoute(import('./views/RequestPasswordReset'), cb)} queries={ViewerQueries} render={render} />
    <Route path=":token" getComponent={(location, cb) => loadRoute(import('./views/CompletePasswordReset'), cb)} queries={ViewerQueries} render={render} />
  </Route>
);



// WEBPACK FOOTER //
// ../src/client/apps/password/index.js